import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { connectService, deleteConnection, getConnections, syncConnection } from '@/api/integrations'

export function useConnections() {
  return useQuery({
    queryKey: ['integrations'],
    queryFn: getConnections,
  })
}

export function useConnect() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ provider, token }: { provider: string; token: string }) =>
      connectService(provider, token),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  })
}

export function useSyncConnection() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => syncConnection(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['integrations'] })
      // 取り込みで実績が増える／更新されるため一覧を再取得
      qc.invalidateQueries({ queryKey: ['achievements'] })
    },
  })
}

export function useDeleteConnection() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteConnection(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations'] }),
  })
}
